import React, { useState, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

import { AppBar, Box, Button, IconButton, Toolbar, Typography, Menu, MenuItem, Divider } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import VpnKeyIcon from "@mui/icons-material/VpnKey";

import AuthContext from "../../store/auth-context";
import Title from "./Title";
import { Team } from "@sharedTypes/team";
import useCheckIfAdmin from "@/hooks/useCheckIfAdmin";
import { useApiQuery } from "@/api/useApi";

const TopBar = () => {
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);

  const { isLoggedIn, userName } = authCtx;

  const [hiddenIfHomePage, setHiddenIfHomePage] = useState("hidden");
  const [anchorEl, setAnchorEl] = useState<(EventTarget & HTMLButtonElement) | null>(null);

  const location = useLocation();

  if (location.pathname === "/" && hiddenIfHomePage !== "hidden") {
    setHiddenIfHomePage("hidden");
  } else if (location.pathname !== "/" && hiddenIfHomePage === "hidden") {
    setHiddenIfHomePage("");
  }

  const handleMenu = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const userTeamsQuery = useApiQuery<{ activeTeams: Team[]; finishedTeams: Team[] }>({
    url: "teams/getUserTeams/",
    queryKey: ["userTeams", authCtx.token],
    enabled: !!authCtx.token,
  });
  const activeUserTeams = userTeamsQuery.data?.activeTeams;

  return (
    <AppBar position="relative" color="transparent" sx={{ boxShadow: "none" }}>
      <Toolbar disableGutters>
        <Box>
          <Title />
        </Box>
        <Box sx={{ ml: "auto", mr: { md: 2 } }}>
          {isLoggedIn ? (
            <>
              <IconButton
                sx={{ display: "flex", alignItems: "end", borderRadius: 3, py: 0.5 }}
                onClick={(e) => handleMenu(e)}
                aria-controls="menu-user"
                aria-haspopup="true"
              >
                <Typography variant="subtitle1" sx={{ pb: 0.3, wordBreak: "break-word", textAlign: "end" }}>
                  {userName}
                </Typography>
                <PersonIcon fontSize="large" />
              </IconButton>
              <Menu open={Boolean(anchorEl)} anchorEl={anchorEl} id="menu-user" onClose={(e) => handleClose()}>
                <MenuItem
                  onClick={() => {
                    handleClose();
                    navigate(`/profile/${authCtx.userId}`);
                  }}
                >
                  Profil
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleClose();
                    authCtx.logout();
                  }}
                >
                  Log ud
                </MenuItem>
                {/* ACTIVE USERTEAMS */}
                {activeUserTeams?.length
                  ? [
                      <Divider key={12324242} />,
                      <Box sx={{ px: "16px", fontSize: 14, textAlign: "center" }} key={21312455}>
                        AKTIVE HOLD
                      </Box>,
                      ...activeUserTeams.map((team) => {
                        if (typeof team.raceId !== "object") return null;
                        return (
                          <MenuItem
                            key={team._id}
                            onClick={() => {
                              handleClose();
                              navigate(`/team/${team._id}`);
                            }}
                          >
                            <div>
                              <div>{team.name}</div>
                              <Box sx={{ fontSize: 11, color: "text.secondary" }}>{team.raceId.fullName}</Box>
                            </div>
                          </MenuItem>
                        );
                      }),
                    ]
                  : null}
                <AdminMenuItems handleClose={handleClose} navigate={navigate} />
              </Menu>
            </>
          ) : (
            <>
              <Button component={Link} variant="contained" to="/login" sx={{ display: { xs: "none", sm: "inline-flex" }, mr: 2 }}>
                Log ind
              </Button>
              <IconButton component={Link} to="/login" sx={{ display: { xs: "inline-flex", sm: "none" }, mr: 0.5 }}>
                <VpnKeyIcon />
              </IconButton>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );

};

export default TopBar;

function AdminMenuItems({ handleClose, navigate }: { handleClose: () => void; navigate: (to: string) => void }) {
  const { isAdmin } = useCheckIfAdmin();

  if (!isAdmin) return null;

  return (
    <>
      <Divider key="43dfrgdgz" />
      <Box
        sx={{ px: "16px", fontSize: 12, textAlign: "center", color: "lightgrey", textDecoration: "underline" }}
        className="text-center text-sm"
        key="rtgfxvzase"
      >
        ADMIN
      </Box>
      <MenuItem
        onClick={() => {
          handleClose();
          navigate(`/admin`);
        }}
        key="5464sdgzf"
      >
        Admin
      </MenuItem>
      <MenuItem
        onClick={() => {
          handleClose();
          navigate(`/admin/emails`);
        }}
        key="462<szdfzg"
      >
        Emails
      </MenuItem>
      <MenuItem
        onClick={() => {
          handleClose();
          navigate(`/birthdays`);
        }}
        key="3643sggfd"
      >
        Birthdays
      </MenuItem>
    </>
  );
}
